export default "__VITE_ASSET__DCh6qL9$__"